<script lang="ts">
  let { onretry, ondismiss }: { onretry: () => void; ondismiss: () => void } = $props();
</script>

<div class="chart-note" role="status">
  <span>Some chart areas didn't load.</span>
  <button class="retry" onclick={onretry}>Retry</button>
  <button class="dismiss" aria-label="dismiss chart loading notice" onclick={ondismiss}>×</button>
</div>

<style>
  .chart-note {
    display: flex;
    align-items: center;
    gap: var(--sp-4);
    padding: var(--sp-3) var(--sp-3) var(--sp-3) var(--sp-5);
    border: 1px solid var(--am-line);
    border-radius: var(--r-2);
    background: var(--panel);
    color: var(--ink);
    font: var(--fs-read) / var(--lh-read) var(--sans);
    box-shadow: var(--el-2);
    pointer-events: auto;
  }
  button {
    flex: none;
    min-height: var(--h-touch);
    border: 0;
    border-radius: var(--r-2);
    background: none;
    cursor: pointer;
  }
  .retry {
    color: var(--ink);
    padding: 0 var(--sp-3);
    font: inherit;
  }
  .dismiss {
    width: var(--h-touch);
    color: var(--sub);
    font: 20px/1 var(--sans);
  }
</style>
